import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { RootState } from '../store/index';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const { token, expiresAt } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if token exists
    if (!token) {
      navigate('/');
      return;
    }

    // Check if expiresAt exists
    if (!expiresAt) {
      navigate('/');
      return;
    }

    // Check if token is expired
    const currentTime = new Date().getTime();
    const expirationTime = new Date(expiresAt).getTime();
    
    if (currentTime >= expirationTime) {
      navigate('/');
      return;
    }
  }, [token, expiresAt, navigate]);

  // If token is valid and not expired, render children
  if (token && expiresAt) {
    const currentTime = new Date().getTime();
    const expirationTime = new Date(expiresAt).getTime();
    
    if (currentTime < expirationTime) {
      return <>{children}</>;
    }
  }

  // Return null while redirecting
  return null;
};

export default AuthGuard;
